export const DOMAIN = 'Presentation';
export const BOTTOM_GAP_UNDER_CARD_SCROLLER = 51;
